import { LineChart } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgChart = mkIcon(LineChart);
